var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component, createRef } from 'react';
import classnames from 'classnames';
import TextareaAutosize from 'react-textarea-autosize';
import { FormFieldContext } from '../FormField';
export class TextArea extends Component {
    constructor() {
        super(...arguments);
        this.textAreaRef = createRef();
        this.focus = () => this.textAreaRef.current.focus();
        this.select = () => this.textAreaRef.current.select();
        this.handleChange = (e) => {
            if (this.props.onChange) {
                this.props.onChange(e, Object.assign(Object.assign({}, this.props), { value: e.target.value }));
            }
        };
        this.handleInput = (e) => {
            if (this.props.onInput) {
                this.props.onInput(e, Object.assign(Object.assign({}, this.props), { value: e.target.value }));
            }
        };
    }
    render() {
        const _a = this.props, { autoHeight, className, disabled, error, onChange, onInput, rows = 3, maxRows = 16 } = _a, rest = __rest(_a, ["autoHeight", "className", "disabled", "error", "onChange", "onInput", "rows", "maxRows"]);
        const { labelFor: inputId } = this.context;
        const TextAreaClasses = classnames('TextArea', className, {
            'TextArea--disabled': disabled,
            'TextArea--error': error,
            'TextArea--auto-height': autoHeight,
        });
        const textarea = (React.createElement("textarea", Object.assign({}, rest, { className: TextAreaClasses, disabled: disabled, onChange: this.handleChange, onInput: this.handleInput, rows: rows, ref: this.textAreaRef, id: this.props.id || inputId, "data-anvil-component": "TextArea" })));
        const textareaAutoHeight = (React.createElement(TextareaAutosize, Object.assign({}, rest, { className: TextAreaClasses, disabled: disabled, onChange: this.handleChange, onInput: this.handleInput, minRows: rows, maxRows: maxRows, ref: this.textAreaRef, cacheMeasurements: true, id: this.props.id || inputId, "data-anvil-component": "TextArea" })));
        return autoHeight ? textareaAutoHeight : textarea;
    }
}
TextArea.contextType = FormFieldContext;
TextArea.displayName = 'TextArea';
//# sourceMappingURL=TextArea.js.map